import { SET_CURRENT_PAGE_NAME, SET_ACTIVE_WORKSPACE_SLUG, BOOTED_APPLICATION } from 'actions'

const initialState = {
  currentWorkspaceSlug: '',
  isBooting: true,
  name: ''
}

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case SET_CURRENT_PAGE_NAME:
      return {
        ...state,
        name: payload
      }
    case SET_ACTIVE_WORKSPACE_SLUG:
      return {
        ...state,
        currentWorkspaceSlug: payload
      }
    case BOOTED_APPLICATION:
      return {
        ...state,
        isBooting: false
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/application/page.js